import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDownload = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	enableBackground: "new 0 0 100 100",
	xmlSpace: "preserve",
	viewBox: "14 8 72 84",
	...props,
	children: [/* @__PURE__ */ _jsx("path", { d: "M83,74c-1.657,0-3,1.343-3,3v9H20v-9c0-1.657-1.343-3-3-3s-3,1.343-3,3v12c0,1.657,1.343,3,3,3h66c1.657,0,3-1.343,3-3V77  C86,75.343,84.657,74,83,74z" }), /* @__PURE__ */ _jsx("path", { d: "M47.878,73.12c0,0.001,0.001,0.001,0.002,0.002L50,75.259l2.12-2.137c0.001,0,0.002-0.001,0.002-0.002L79.13,45.9  c1.167-1.176,1.159-3.076-0.017-4.243c-1.176-1.166-3.075-1.16-4.243,0.017L53,63.717V11c0-1.657-1.343-3-3-3s-3,1.343-3,3v52.717  L25.13,41.674c-1.168-1.177-3.067-1.183-4.243-0.017c-1.176,1.167-1.184,3.067-0.017,4.243L47.878,73.12z" })]
});
export default SvgDownload;
